import React from 'react';
import { useAuth } from '../hooks/useAuth';
import Dashboard from '../components/Dashboard';

const DashboardPage = () => {
  const { user } = useAuth();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Dashboard</h1>
      {user ? (
        <Dashboard />
      ) : (
        <p>Por favor, inicia sesión para ver tu dashboard.</p>
      )}
    </div>
  );
};

export default DashboardPage;